import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};

  ${props =>
    props.isRequired &&
    `
    ::after {
      content: '*';
      color: ${tokens.color.error.main};
      padding-left: 2px;
    }
  `}
`

export const SwitchRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  ${Label} {
    margin-bottom: 0;
  }
`

export const Alert = styled.div`
  margin-top: 16px;
`
